import React from "react";
import { BrainIcon, ClipboardListIcon, CompassIcon, LayoutGridIcon, LibraryIcon, SearchIcon, TableIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { tools } from "../data/landing";
const iconMap = {
  worksheet: ClipboardListIcon,
  matrix: TableIcon,
  map: CompassIcon,
  chart: LayoutGridIcon,
  search: SearchIcon,
  library: LibraryIcon,
  brain: BrainIcon
};
export function Tools() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="tools" data-id="element-292" data-mp="244ke6lfwbk14">
      <div className="mx-auto max-w-5xl" data-id="element-293" data-mp="246n4l6kynf6d">
        <SectionHeading title={<span id="tools" data-id="element-295" data-mp="1qbbb12ijjur1">
              Plus, you'll receive <span className="text-cyan" data-id="element-296" data-mp="1vbp6ll2yhc86">professional reference tools</span>
            </span>} data-id="element-294" data-mp="1qe770latw9cu" />

        <ul className="grid gap-x-10 gap-y-1 md:grid-cols-2" data-id="element-297" data-mp="2j1b669n8ptgp">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 border-b border-line py-5" data-id="element-298" data-mp="2p1e93stgucgn">
                <Icon className="mt-0.5 h-7 w-7 shrink-0 text-gold" aria-hidden="true" data-id="element-299" data-mp="2ozb7ebiyauw3" />
                <div data-id="element-300" data-mp="2kxziy9btcfph">
                  <h3 className="text-[17px] font-bold text-white" data-id="element-301" data-mp="2yr78lvgc314j">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-mist" data-id="element-302" data-mp="2ytbnf8frtkjl">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[16px] font-medium text-white" data-id="element-303" data-mp="38oc0mbwv1qt9">
          Everything is organized to help you review the information without jumping between disconnected reference materials.
        </p>

        <CtaButton className="mt-10" label="Organize my references today" data-id="element-304" data-mp="3hnyyinqdsehk" />
      </div>
    </section>;
}